import { cx } from '@flowus/common/cx';
import { Icon } from '@flowus/common/icon-svg/pc-icon';
import { ViewPath } from '@flowus/common/static-const';
import { Link } from 'react-router-dom';
import { PRODUCT_AI_TITLE } from 'src/const/title';
import { useIsGuest } from 'src/hooks/share/use-permission-utils';
import { $appUiStateCache, setAppUiState } from 'src/services/app/hook';
import { useCheckChatPage } from 'src/utils/getPageId';

export const AiToc = () => {
  const isChatPage = useCheckChatPage();
  const isGuest = useIsGuest();

  const openAiHistory = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setAppUiState({ $showAiHistory: !$appUiStateCache.$showAiHistory });
  };
  // 协作者不显示，没权限
  if (isGuest) return null;

  return (
    <Link
      to={ViewPath.chat}
      className={cx(
        'text-t2 relative mx-2 px-2 flex items-center space-x-2 rounded-md animate-hover-black3 py-1 my-2 justify-between group',
        { 'normal-bg': isChatPage }
      )}
    >
      <div className="flex items-center space-x-2">
        <Icon name="IcAiFill" size="middle" className="text-ai_color" />
        <div
          className={cx('flex-1 text-t2-medium text-grey2 animate-hover-black3', {
            'text-black': isChatPage,
          })}
        >
          {PRODUCT_AI_TITLE}
        </div>
      </div>
      <Icon
        name="IcHistory"
        size="small"
        boxSize="middle"
        className="text-grey3 animate-hover"
        onClick={openAiHistory}
      />
    </Link>
  );
};
